<template>
<div>
    <ul class="sa-setting-list">
        <li v-for="(item,i) in classData" :key="i" class="active">
            <div class="d-f-spacebet">
                <strong>{{item.title}}</strong>
                <el-switch v-model="item.active"></el-switch>
            </div>
            <p>{{item.desc}}</p>
        </li>
    </ul>
    <div v-loading="loader" element-loading-spinner="el-icon-loading"></div>
</div>
</template>

<script>
import API from "../../services/api.js";
export default {
    data() {
        return {
            classData:{},
            loader:true
        }
    },
    methods:{
        callingClassification(){
            let _self = this
            _self.loader = true
            API.classificationList( function (res) {
            if (res.status == 1000) {
                _self.classData = res.data
                _self.loader = false
            } else {
              _self.$message({
                message: "error",
                type: 'error',
              });
            }
          });
        },
        closeIcon(){
            this.$emit("closeTab");
        },
   saveNotificationList(){
    let _self = this
      _self.loader = true
    let switches = {}
    for(let c of _self.classData){
        switches[c.code]=c.active
        }
            API.getNotificationList(switches, function (response) {
            if (response.status == 1000) {
                _self.loader = false
            _self.$message({
                message: "Updated Successfully!",
                type: 'success',
              });
              _self.$emit('getNotify')
            } else {
              _self.$message({
                message: "Error While Saving",
                type: 'error',
              });
            }
          });
        },

    },
    mounted(){
        this.callingClassification()
    }
};
</script>
<style scoped>
.sa-setting-list {max-height: 400px; overflow: auto;padding-right: 10px;margin-top: 15px;}
/* .el-loading-spinner {margin-top: 30px;} */
</style>



// WEBPACK FOOTER //
// src/components/notification/NotificationSettings.vue